import { createSchema } from 'morphism';
import { getCardsListCards } from '../../utils/cleanProps';

export const schemaCardsList = createSchema<any, any>({
  backgroundColor: 'backgroundColor',
  isDark: 'isDark',
  cards: {
    path: ['cards', 'screenSize', 'locale', 'section'],
    fn: ({ cards, screenSize, locale, section }: any) => {

      if (cards)
        return getCardsListCards({
          cards,
          screenSize,
          locale,
          section,
        });
    },
  },
  surtitle: 'surtitle',
  title: 'title',
  subtitle: 'cardsListSubtitle',
  shouldDisplay: 'shouldDisplayElements',
  seeMoreBatchSize: 'seeMoreBatchSize',
  buttonType: {
    path: 'seeMoreButtonVariation',
    fn: (seeMoreButtonVariation: any) => {
      return seeMoreButtonVariation || 'minimal';
    },
  },
  layout: 'layout',
  className: 'className',
  addSeeMoreButton: 'addSeeMoreButton',
  seeMoreButtonLabel: 'seeMoreButtonLabel',
  id: {
    path: 'title',
    fn: (title?: string) => {
      return title?.replace(/\W+/g, '-');
    },
  },
  __typename: '__typename',
});
